// extracted by mini-css-extract-plugin
module.exports = {"agentDetailsModalContent":"RtdWindow_agentDetailsModalContent__1Q2Qt","userDetails":"RtdWindow_userDetails__1-Fsg","userDetailsFlex":"RtdWindow_userDetailsFlex__1nTut"};